
export const  ENCRYPTION = {  
    iv:"0123456789ABCDEF",
    chars: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
}

export const HTTP_HEADERS = {
    CONTENT_TYPE: 'Content-Type',
    ACCEPT: 'Accept',
    EDATA: 'eData',
    BLOB: 'blob',
};
  
export const HTTP_METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};

//----PROD
export const BASE_URL = 'https://investonline.itiamc.com';

//----CLIENT UAT
// export const BASE_URL = 'https://dev.itiamc.com:8486';

//----ROBO SIT
// export const BASE_URL = 'https://jeethinvestor.robosoftin.com:8090';

//----Local
// export const BASE_URL = 'http://jeethinvestor.robosoftin.com:9007';

//----DR
// export const BASE_URL = 'https://drinvestor.itiamc.com';


export const API_PATH = `${BASE_URL}/api/v1`;
export const OPEN_LINK = `${BASE_URL}/`;

export const SERVICES = {}